export const parseQueryParams = (query = '') => {
    if (!query.includes('?')) {
        return {};
    }
    const hashes = query.slice(query.indexOf(`?`) + 1).split(`&`);
    return hashes.reduce((acc, hash) => {
        const [key, val] = hash.split(`=`);
        return key
            ? {
                ...acc,
                [decodeURIComponent(key)]: decodeURIComponent(val?.replace(/\+/g, ' ')),
            }
            : acc;
    }, {});
};
export const encodeQueryParams = (params, skipEncoding = []) => {
    const encodedParams = Object.entries(params)
        .filter(([, val]) => val !== undefined && val !== 'undefined')
        .map(([key, value]) => (skipEncoding.includes(key) ? `${key}=${value}` : handleValues(key, value)));
    return `?${encodedParams.join('&')}`;
};
export const addQueryParams = (url = '', queryParams) => {
    const params = Object.entries(queryParams)
        .map(([key, value]) => (!Object.is(value, undefined) ? handleValues(key, value) : undefined))
        .filter(entry => !Object.is(entry, undefined));
    if (!params.length) {
        return url;
    }
    return `${url}${url.includes('?') ? '&' : '?'}${params.join('&')}`;
};
const handleValues = (key, value) => {
    if (Array.isArray(value)) {
        return value.length
            ? value.map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&')
            : undefined;
    }
    else {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
};
export const removeQueryParam = (url = '', param) => {
    const params = parseQueryParams(url);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete params[param];
    return `${url.split('?')[0]}${Object.keys(params).length ? encodeQueryParams(params) : ''}`;
};
export const prependHTTP = (url) => url && (/^https?:\/\/.+$/i.test(url) ? url : `http://${url}`);
export const stringifyParams = (params) => {
    const stringParams = {};
    Object.entries(params).forEach(([key, value]) => (stringParams[key] = value?.toString()));
    return stringParams;
};
//# sourceMappingURL=url.js.map